import type { UserAccessRightsInterface } from '@app/types/NewAccessRight';

import type { WithActiveBranchId } from '../shared';

export enum AccessRightsEndpoints {
  GetUserAccessRights = 'GetUserAccessRights',
  UpdateUserAccessRights = 'UpdateUserAccessRights',
  GetAccessRightsTemplate = 'GetAccessRightsTemplate',
  GetAccessRightsTemplates = 'GetAccessRightsTemplates',
  UpdateAccessRightsTemplate = 'UpdateAccessRightsTemplate',
  DeleteAccessRightsTemplate = 'DeleteAccessRightsTemplate',
  UpdateAccessRightsTemplateByUserId = 'UpdateAccessRightsTemplateByUserId',
  ApplyAccessRightsTemplate = 'ApplyAccessRightsTemplate',
  UpdateAccessRightsTemplates = 'UpdateAccessRightsTemplates',
  UpdateAccessRightsModules = 'UpdateAccessRightsModules',
}

export interface ModelAccessRightsTemplate {
  Id: number;
  TimeCreated: string;
  CreateUserId: number;
  FromUserId: number;
  Name: string | null;
  Description: string | null;
  ModelAccessRights: UserAccessRightsInterface;
}

export interface AccessRightsModuleDto {
  Name: string | null;
  RightType: number;
  Allowed: boolean;
}

export type GetUserAccessRightsRequest = WithActiveBranchId<{
  forUserId: number;
}>;

export type UpdateUserAccessRightsRequest = WithActiveBranchId<{
  data: UserAccessRightsInterface;
}>;

export type GetAccessRightsTemplateRequest = WithActiveBranchId<{
  templateId: number;
}>;

export type GetAccessRightsTemplatesRequest = WithActiveBranchId;

export type UpdateAccessRightsTemplateRequest = WithActiveBranchId<{
  data: ModelAccessRightsTemplate;
}>;

export type DeleteAccessRightsTemplateRequest = WithActiveBranchId<{
  templateId: number;
}>;

export type UpdateAccessRightsTemplateByUserIdRequest = WithActiveBranchId<{
  data: ModelAccessRightsTemplate;
}>;

export type ApplyAccessRightsTemplateRequest = WithActiveBranchId<{
  AccessRightsTemplateId: number;
  UserId: number;
}>;

export type UpdateAccessRightsTemplatesRequest = WithActiveBranchId;

export type UpdateAccessRightsModulesRequest = WithActiveBranchId<{
  organizationId: number;
  data: AccessRightsModuleDto[];
}>;

export type GetUserAccessRightsResponse = UserAccessRightsInterface;
export type UpdateUserAccessRightsResponse = UserAccessRightsInterface;
export type GetAccessRightsTemplateResponse = ModelAccessRightsTemplate;
export type GetAccessRightsTemplatesResponse = ModelAccessRightsTemplate[];
export type UpdateAccessRightsTemplateResponse = ModelAccessRightsTemplate;
export type DeleteAccessRightsTemplateResponse = void;
export type UpdateAccessRightsTemplateByUserIdResponse =
  ModelAccessRightsTemplate;
export type ApplyAccessRightsTemplateResponse = UserAccessRightsInterface;
export type UpdateAccessRightsTemplatesResponse = void;
export type UpdateAccessRightsModulesResponse = void;
